import { data } from '../../svg/Primary/data';
import { makeIcon } from '../makeIcon';

export const Primary = makeIcon(data, 'primary', 'Primary');

export default Primary;
